import { render, staticRenderFns } from "./CFooter.vue?vue&type=template&id=c6f81b2e&"
import script from "./CFooter.ts?vue&type=script&lang=ts&"
export * from "./CFooter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports